import {
    gncActions, displayForms
} from "./newCaseActions"

const initialState = {
    initialState: true,
    kreditorId: '',
    debitorList: [],
    debitorListFiltered: [],
    preCaseId: '',

    countryList: [],
    currencyList: [],
    postalList: [],
    basicDataFetched: false,
    filterString: '',
    selectedDebitor: {},
    existingDebitor: false,
    debitorInfo: {},
    differentDebitor: false,
    clearFakturaInfo: false,
    clearPdf: false,
    debitorIsSet: false,
    pdfInfo: {},
    pdfUrl: '',
    fileInfo: [],
    pdfInfoError: '',
    fakturaHeader: '',
    lineNo: 0,
    editLineNo: null,
    invoices: [],
    displayForm: displayForms.DEBITORFILTER,
    showReceiptAlert: false,
    fetched: false,
    loading: false,
    pdfInfoLoading: false,
    getPreCaseLoading: false,
    pdfLoading: false,
    checkingInvoiceNumber: false,
    invoiceNumberIsDuplicate: null,
    error: ''
}

// Sjekker på om opplastet faktura inneholder samme debitor som forrige faktura
function isDifferentDebitor(existingInfo, newData) {
    if (!existingInfo || Object.keys(existingInfo).length === 0) {
      // Trenger ikke sjekke på match da state.debitorInfo er tom
      return false;
    }
    if (existingInfo.debtorType === 'Næring' && newData.customerType === 'N') {
      // Se om match for Næring 
      return !(existingInfo.debtorName === newData.companyName &&
               existingInfo.postalAddress === newData.kosAddressList[0].addressLine);
    } else if (existingInfo.debtorType === 'Privat' && newData.customerType === 'P') {
      // Se om match for Privat
      return !(existingInfo.firstName === newData.firstName &&
               existingInfo.lastName === newData.lastName &&
               existingInfo.postalAddress === newData.kosAddressList[0].addressLine);
    }
    // Ingen match, sett til true og informer bruker med modal
    return true;
}

const newCaseReducer = (state = initialState, action) => {

    switch (action.type) {

        case gncActions.LOADING:
            return {
                ...state,
                loading: true,
                error: null,
                pdfInfoError: null
            };

        case gncActions.PDFLOADING:
            return {
                ...state,
                loading: false,
                pdfInfoLoading: false,
                getPreCaseLoading: false,
                pdfLoading: true,
                error: null,
                pdfInfoError: null
            };

        case gncActions.PDFINFOLOADING:
            return {
                ...state,
                loading: false,
                pdfInfoLoading: true,
                pdfLoading: false,
                error: null,
                pdfInfoError: null,
                differentDebitor: false,
                clearFakturaInfo: false,
                clearPdf: false,
                showReceiptAlert: false
            };
        
        case gncActions.PRECASEIDLOADING:
            return {
                ...state,
                loading: false,
                pdfInfoLoading: false,
                differentDebitor: false,
                getPreCaseLoading: true,
                pdfLoading: false,
                error: null,
                pdfInfoError: null,
                clearFakturaInfo: false,
                showReceiptAlert: false
            };

        case gncActions.CHECKINGINVOICENUMBER:
            return {
                ...state,
                loading: false,
                pdfInfoLoading: false,
                differentDebitor: false,
                getPreCaseLoading: false,
                pdfLoading: false,
                checkingInvoiceNumber: true,
                invoiceNumberIsDuplicate: null,
                error: null,
                pdfInfoError: null,
                clearFakturaInfo: false,
                showReceiptAlert: false
            }; 

        case gncActions.CHECKEDINVOICENUMBER:
            return {
                ...state,
                loading: false,
                pdfInfoLoading: false,
                differentDebitor: false,
                getPreCaseLoading: false,
                pdfLoading: false,
                checkingInvoiceNumber: false,
                invoiceNumberIsDuplicate: action.data.error,
                error: null,
                pdfInfoError: null,
                clearFakturaInfo: false,
                showReceiptAlert: false
            };

        case gncActions.ERROR:
            return {
                ...state,
                loading: false,
                error: action.data.error
            };

        case gncActions.PDFINFOFAILED:
            return {
                ...state,
                selectedDebitor: {},
                invoices: [],
                caseId: '',
                fakturaHeader: '',
                existingDebitor: false,
                differentDebitor: false,
                loading: false,
                pdfInfoLoading: false,
                pdfLoading: false,
                pdfInfoError: action.data.error,
                error: null,
                clearFakturaInfo: false
            };

        case gncActions.TEMPORARYCASEFAILED:
            return {
                ...state,
                loading: false,
                pdfInfoLoading: false,
                getPreCaseLoading: false,
                pdfLoading: false,
                pdfInfoError: action.data.error,
                error: null,
                clearFakturaInfo: false,
                showReceiptAlert: false
            };

        case gncActions.PDFINFOFETCHED:
            const differentDebitor = isDifferentDebitor(state.debitorInfo, action.data);            
            return {
                ...state,
                pdfInfo: { ...action.data },
                pdfUrl: action.data.pdfUrl,
                fileInfo: action.data.fileInfo,
                differentDebitor: differentDebitor,
                filterString: '',
                caseId: '',
                fetched: true,
                loading: false,
                pdfInfoLoading: false,
                pdfLoading: false,
                error: null,
                pdfInfoError: null,
                clearFakturaInfo: false,
                showReceiptAlert: false
            };
        case gncActions.CLEARPDFINFO:
            return {
                ...state,
                selectedDebitor: {},
                debitorInfo: {},
                invoices: [],
                fileInfo: [],
                pdfInfo: {},
                pdfUrl: '',
                filterString: '',
                caseId: '',
                lineNo: 0,
                differentDebitor: false,
                fetched: true,
                loading: false,
                pdfInfoLoading: false,
                pdfLoading: false,
                pdfInfoError: null,
                error: null,
                clearFakturaInfo: false,
                debitorIsSet: false,
                showReceiptAlert: false
            }

        case gncActions.CLEARDIFFERENTDEBITOR:
            return {
                ...state,
                fileInfo: [],
                differentDebitor: false,
                fetched: true,
                loading: false,
                pdfInfoLoading: false,
                pdfLoading: false,
                pdfInfoError: null,
                error: null,
                clearFakturaInfo: true,
            }

        case gncActions.DEBITORSFETCHED:
            return {
                ...state,
                displayForm: displayForms.DEBITORFILTER,
                kreditorId: action.data.kreditorId,
                debitorList: [...action.data.debitorList],
                debitorListFiltered: [...action.data.debitorList],
                defaultProduct: action.data.defaultProduct,
                filterString: '',
                selectedDebitor: {},
                preCaseId: '',
                caseId: '',
                fetched: true,
                loading: false,
                error: null,
                pdfInfoError: null
            };

        case gncActions.DEBITORSFILTERED:
            return {
                ...state,
                displayForm: displayForms.DEBITORFILTER,
                debitorListFiltered: [...action.data.debitorListFiltered],
                filterString: action.data.filterString,
                loading: false,
                error: null
            };

        case gncActions.SELECTDEBITOR:
            return {
                ...state,
                initialState: false,
                displayForm: displayForms.EDITDEBITOR,
                selectedDebitor: { ...action.data.selectedDebitor },
                invoices: [],
                fakturaHeader: '',
                preCaseId: '',                
                caseId: '',
                existingDebitor: true,
                loading: false,
                error: null,
                pdfInfoError: null,
                clearFakturaInfo: false
            };

        case gncActions.NEWDEBITOR:
            return {
                ...state,
                displayForm: displayForms.EDITDEBITOR,
                selectedDebitor: {},
                invoices: [],
                preCaseId: '',
                caseId: '',
                fakturaHeader: '',
                existingDebitor: false,
                loading: false,
                error: null,
                pdfInfoError: null
            };

        case gncActions.NEWDEBITORWITHAI:
            return {
                ...state,
                displayForm: displayForms.EDITDEBITORWITHAI,
                selectedDebitor: {},
                invoices: [],
                preCaseId: '',
                caseId: '',
                fakturaHeader: '',
                existingDebitor: false,
                loading: false,
                error: null,
                pdfInfoError: null,
                clearFakturaInfo: false,
                showReceiptAlert: false
            };

        case gncActions.SETFAKTURAHEADER:
            return {
                ...state,
                fakturaHeader: action.data,
                loading: false,
                error: null,
                pdfInfoError: null
            }

        case gncActions.SETBASICDATA:
            return {
                ...state,
                countryList: [...action.data.countryList],
                currencyList: [...action.data.currencyList],
                postalList: [...action.data.postalList],
                basicDataFetched: true,
                loading: false,
                error: null,
                pdfInfoError: null
            };

        case gncActions.VISUPLOADFAKTURA:
            return {
                ...state,
                displayForm: displayForms.FAKTURAUPLOAD,
                preCaseId: action.data,
                caseId: '',
                invoices: [],
                editLineNo: null,
                loading: false,
                error: null,
                pdfInfoError: null
            };
            
        case gncActions.TEMPORARYCASEIDFETCHED:
            return {
                ...state,
                debitorInfo: action.data.debitorInfo,
                preCaseId: action.data.preCaseId,
                caseId: '',
                invoices: [],
                editLineNo: null,
                loading: false,
                pdfLoading: false,
                error: null,
                pdfInfoError: null,
                showReceiptAlert: false
            };

        case gncActions.FAKTURAUPLOADED:
            return {
                ...state,
                displayForm: displayForms.FAKTURAUPLOAD,
                invoices: [...action.data.invoiceList],
                lineNo: action.data.lineNo,
                editLineNo: null,
                loading: false,
                pdfLoading: false,
                error: null,
                pdfInfoError: null
            };

        case gncActions.FAKTURAUPLOADEDWITHAI:
            return {
                ...state,
                invoices: [...action.data.invoiceList],
                lineNo: action.data.lineNo,
                fileInfo: [],
                clearFakturaInfo: true,
                clearPdf: true,
                differentDebitor: false,
                debitorIsSet: true,
                editLineNo: null,
                loading: false,
                pdfInfoLoading: false,
                pdfLoading: false,
                getPreCaseLoading: false,
                error: null,
                pdfInfoError: null,
                showReceiptAlert: false
            };

        case gncActions.EDITFAKTURA:
            return {
                ...state,
                displayForm: displayForms.FAKTURAUPLOADEDIT,
                editLineNo: action.data.lineNo,
                loading: false,
                error: null,
                pdfInfoError: null
            };
            
        case gncActions.EDITFAKTURAWITHAI:
            return {
                ...state,
                displayForms: displayForms.FAKTURAUPLOADEDITWITHAI,
                editLineNo: action.data.lineNo,
                clearFakturaInfo: false,
                loading: false,
                pdfInfoLoading: false,
                pdfLoading: false,
                getPreCaseLoading: false,
                error: null,
                pdfInfoError: null,
                showReceiptAlert: false
            };

        case gncActions.FAKTURADELETED:
            return {
                ...state,
                displayForm: displayForms.FAKTURAUPLOAD,
                invoices: [...action.data],
                editLineNo: null,
                loading: false,
                error: null,
                pdfInfoError: null
            }

        case gncActions.FAKTURADELETEDWITHAI:
            return {
                ...state,
                invoices: [...action.data],
                editLineNo: null,
                loading: false,
                getPreCaseLoading: false,
                pdfLoading: false,
                error: null,
                pdfInfoError: null,
                showReceiptAlert: false
            }

        case gncActions.EMPTYFAKTURA:
            return {
                ...state,
                displayForm: displayForms.FAKTURAUPLOADEDIT,
                editLineNo: null,
                loading: false,
                error: null,
                pdfInfoError: null
            };

        case gncActions.FAKTURAFINALIZED:
            return {
                ...state,
                displayForm: displayForms.RECEIPT,
                preCaseId: '',
                caseId: action.data,
                invoices: [],
                lineNo: 0,
                loading: false,
                error: null,
                pdfInfoError: null
            }

        case gncActions.FAKTURAFINALIZEDWITHAI:
            return {
                ...state,
                preCaseId: '',
                caseId: action.data,
                invoices: [],
                fileInfo: [],
                loading: false,
                pdfInfoLoading: false,
                getPreCaseLoading: false,
                pdfLoading: false,
                error: null,
                pdfInfoError: null,
                debitorInfo: {},
                differentDebitor: false,
                clearFakturaInfo: true,
                debitorIsSet: false,
                pdfInfo: {},
                pdfUrl: '',
                lineNo: 0,
                showReceiptAlert: true
            };

        case gncActions.NO_DATA:
            return {
                ...initialState,
                loading: false,
                error: action.data
            };

        case gncActions.RESETCONTAINER:
            return {
                ...state,
                initialState: true,
                //kreditorId: '',
                filterString: '',
                selectedDebitor: {},
                fakturaHeader: '',
                debitorListFiltered: state.debitorList,
                existingDebitor: false,
                invoices: [],
                preCaseId: '',
                caseId: '',
                displayForm: displayForms.DEBITORFILTER,
                loading: false,
                error: ''
            }

        default:
            return state;    
    }
}

export default newCaseReducer